export default __webpack_public_path__ + "static/media/architecture-not-selected.bfe6884d.svg";